import { createSlice } from "@reduxjs/toolkit";

export const eocConfigSlice = createSlice({
    name: 'eocConfig',
    initialState: {
        value: undefined
    },
    reducers: {
        setEOCConfig: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setEOCConfig } = eocConfigSlice.actions;

export const getEOCConfig = (state) => state.eocConfig.value;

export default eocConfigSlice.reducer;